import { useAuth } from '../../context/AuthContext';
import { mergeRolePermissions } from '../constants/permissions';

export const usePermissions = () => {
  const { user, companyData } = useAuth();
  const companyRolePermissions = mergeRolePermissions(companyData?.rolePermissions);

  const hasPermission = (permission) => {
    if (!user || !user.role) return false;
    if (user.role === 'owner') return true;

    if (user.permissions && Array.isArray(user.permissions)) {
      if (user.permissions.includes(permission)) {
        return true;
      }
    }

    const rolePermissions = companyRolePermissions[user.role] || [];
    return rolePermissions.includes(permission);
  };

  const hasAllPermissions = (permissions) => {
    return permissions.every((permission) => hasPermission(permission));
  };

  const hasAnyPermission = (permissions) => {
    return permissions.some((permission) => hasPermission(permission));
  };

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
    userRole: user?.role,
    refreshUserPermissions: async () => {},
  };
};
